module.exports = __webpack_public_path__ + "img/logo5.e649b5a7.png";